if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor () {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cartNotification = document.querySelector('cart-notification')
        this.cartItems = document.querySelector('cart-items')
        this.submitButton = this.form.querySelector('button[name="add"]')
        this.productInfoWrapper = this.closest('.product__info-wrapper')
        this.productRadios = Array.from(
          this.productInfoWrapper.querySelectorAll(
            'fostr-variant-radios input[type="radio"]',
          ),
        )
        this.stickySubmitButtonContainer = this.form.querySelector(
          '.product-form__sticky-button',
        )
        this.stickySubmitButton = this.stickySubmitButtonContainer.querySelector(
          'button',
        )
        this.stickySubmitButton.addEventListener(
          'click',
          this.onStickySubmitHandler.bind(this),
        )
        this.createStickyObserver = this.createStickyObserver.bind(this)
        this.stickyObserver = this.createStickyObserver()
        this.stickyObserver.observe(this.submitButton)

        this.productRadios.forEach(productRadio => {
          productRadio.addEventListener('change', event => {
            const submitButton = document.querySelector('.product-form__notify-me')
            const stockMessage = document.querySelector('.product__stock-message')
            const isPreorderEnable = this.dataset.preorderEnable === 'true'

            document.querySelectorAll('.product__sizing__inner').forEach(x => x.setAttribute('aria-hidden', 'true'))

            document.querySelector(`[data-us-size-value="${productRadio.value}"]`)?.removeAttribute('aria-hidden', true)

            if (productRadio.classList.contains('disabled')) {
              this.querySelector('.product-form__sticky-button').setAttribute('aria-hidden', true)
              this.form.classList.remove('singleProductPreOrderForm-noNotify')
              submitButton.classList.add('product-form__submit-hidden')
              submitButton.querySelector('span').innerHTML = window.variantStrings.soldOut

              if (stockMessage) {
                stockMessage.innerHTML = window.productFormStrings.unavailableStockMessage
              }
            } else {
              this.querySelector('.product-form__sticky-button').setAttribute('aria-hidden', false)
              this.form.classList.add('singleProductPreOrderForm-noNotify')
              submitButton.removeAttribute('disabled')
              submitButton.classList.remove('product-form__submit-hidden')
              submitButton.querySelector('span').innerHTML = window.variantStrings.addToCart

              if (isPreorderEnable) {
                submitButton.querySelector('span').innerHTML = window.theme.translations.product.preorder
              }

              if (stockMessage) {
                stockMessage.innerHTML = window.productFormStrings.availableStockMessage
              }
            }
            const wishlistTriggerUpdate = new CustomEvent('wishlist-trigger:update', { detail: { variantId: event.target.dataset.variantId } })
            window.dispatchEvent(wishlistTriggerUpdate)

            this.handleErrorMessage()
            const wishlistError = document.querySelector('[data-fostr-variant-radios="wishlistError"]')
            if (wishlistError) { wishlistError.remove() }
          })
        })
      }

      createStickyObserver () {
        const headerOffset = document.querySelector('sticky-header')?.getBoundingClientRect().height || 0

        return new window.IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              // Target is visible
              this.stickySubmitButtonContainer.classList.remove('is-visible')
              return
            }

            if (entry.boundingClientRect.bottom > headerOffset) {
              // Target is not visible
              // Target is below the viewport
              this.stickySubmitButtonContainer.classList.remove('is-visible')
            } else {
              // Target is not visible
              // Target is above the viewport
              this.stickySubmitButtonContainer.classList.add('is-visible')
            }
          },
          {
            root: null,
            rootMargin: `-${headerOffset}px 0px 0px 0px`,
            threshold: 0,
          },
        )
      }

      onStickySubmitHandler (evt) {
        // Smooth scroll to Product Info
        const headerOffset = 46 + 15 // header height + 15px spacing
        const elementPosition = this.productInfoWrapper.getBoundingClientRect()
          .top
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })

        return this.onSubmitHandler()
      }

      onSubmitHandler (evt) {
        if (evt) evt.preventDefault()

        const submitButton = this.querySelector('[type="submit"]')

        if (submitButton.classList.contains('loading')) return

        this.handleErrorMessage()
        // this.cartItems.setActiveElement(document.activeElement);

        submitButton.setAttribute('aria-disabled', true)
        submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        )

        const config = window.fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        formData.append(
          'sections',
          this.cartItems.getSectionsToRender().map(section => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        config.body = formData

        fetch(`${window.routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              if (response.message === 'Parameter Missing or Invalid') {
                this.handleErrorMessage('Please select a size.')
              } else {
                this.handleErrorMessage(response.description)
              }
              return
            }

            const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
              detail: {
                formName: 'mainProductForm',
                item: response,
              },
            })
            window.dispatchEvent(addToCartEvent)

            this.cartItems.renderContents(response, '', 'addItem')
            return this.cartItems.checkGifts()
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            )
          })
      }

      handleErrorMessage (errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}
